import React, { useContext, useEffect, useState } from "react";
import Paper from "@material-ui/core/Paper";
import Snackbar from "@material-ui/core/Snackbar";
import Slide from "@material-ui/core/Slide";
import MySnackbarContentWrapper from "components/layout/Message";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import AllowancesContext from "context/allowance/allowanceContext";
import { useTranslation } from "react-i18next";
import { useStyles } from "components/layout/CommonStyles";
import Grid from "@material-ui/core/Grid";
import Input from "components/inputs/Input";
import Transition from "components/layout/transition/Transition";
import Footer from "components/layout/Footer";
import { dateToBR } from "utils/dates/DateToBRr";
import ScholarshipRecessesHistoryTable from "./ScholarshipsRecessesHistoryTable";
import ScholarshipRecessesHistoryNavHeader from "./ScholarshipsRecessesHistoryNavHeader";
import DialogViewScholarshipRecess from "./DialogViewScholarshipRecess";

const ScholarshipsRecessesForm = props => {
  const classes = useStyles();
  const [t] = useTranslation();
  const allowanceContext = useContext(AllowancesContext);
  const { context, myRecesses, scholarshipRecessHistory, loading } = props;

  const [open, setOpen] = useState(false);
  const [dialogType, setDialogType] = useState("");

  const [snackBar, setSnackBar] = useState({
    open: false,
    kind: "",
    content: "",
  });

  const { resetAllowanceMessage } = allowanceContext;

  const handleSnackClose = () => {
    setSnackBar({ ...snackBar, open: false });
    resetAllowanceMessage();
  };

  const handleOpenDialog = dialog => {
    setDialogType(dialog);
    setOpen(true);
  };

  const [values, setValues] = useState({
    collaboratorName: "",
    admissionDate: null,
    contractId: 0,
    recessHistory: [],
  });

  useEffect(() => {
    if (
      scholarshipRecessHistory &&
      Object.keys(scholarshipRecessHistory).length !== 0
    ) {
      setValues((old) => ({
        ...old,
        collaboratorName: scholarshipRecessHistory.collaboratorName ?? "",
        admissionDate: scholarshipRecessHistory.admissionDate ?? "",
        contractId: scholarshipRecessHistory.contractId ?? "",
        recessHistory: scholarshipRecessHistory.recessHistory ?? "",
      }));
    }
  }, [scholarshipRecessHistory]);

  const handleChange = (name, value) => {
    let val = value;
    setValues({ ...values, [name]: val });
  };

  const filteredRows = values.recessHistory.filter(
    row => row.deletedAt === null
  );

  return (
    <React.Fragment>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={snackBar.open}
        onClose={handleSnackClose}
        TransitionComponent={Slide}
        transitionDuration={{ enter: 500, exit: 500 }}
        ContentProps={{ "aria-describedby": "message-id" }}
        autoHideDuration={2000}
      >
        <MySnackbarContentWrapper onClose={handleSnackClose} />
      </Snackbar>

      <ScholarshipRecessesHistoryNavHeader
        context={context}
        myRecesses={myRecesses}
      />

      <div
        style={{
          opacity: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "spaceBetween",
          minHeight: "max(calc(75vh - 70px)",
        }}
      >
        <div className="containerNewDesign">
          <Paper>
            <div className="cabecalho">
              {myRecesses
                ? t("HR.myRecesses")
                : context === "edit"
                  ? t("GENERAL.manage").toUpperCase() +
                  " " +
                  t("HR.scholarshipRecess").toUpperCase()
                  : t("GENERAL.view").toUpperCase() +
                  " " +
                  t("HR.scholarshipRecess").toUpperCase()}
            </div>
            <Transition loading={loading} newDesign={true}>
              <Paper>
                <React.Fragment>
                  <Grid className={classes.familyDataForm}>
                    <Grid container item spacing={2} md={12} lg={12}>
                      <Grid item xs={12} sm={3}>
                        <Input
                          disabled
                          label={"HR.collaborator"}
                          value={values.collaboratorName}
                          valueName={"collaborator"}
                          handleChange={handleChange}
                        />
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <Input
                          disabled
                          label={"HR.admissionDate"}
                          value={
                            values.admissionDate
                              ? dateToBR(new Date(values.admissionDate))
                              : ""
                          }
                          valueName={"admissionDate"}
                          handleChange={handleChange}
                        />
                      </Grid>

                      <Box width="100%" />

                      <Box width="100%" />
                      <Grid item xs={12} sm={12}>
                        <Paper
                          style={{ marginTop: "30px", marginBottom: "20px" }}
                        >
                          <div
                            className="cabecalho"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div>{t("HR.history").toUpperCase()}</div>
                            {context === "edit" ? (
                              <span
                                style={{ display: "flex", marginRight: "2rem" }}
                              >
                                <IconButton onClick={() => handleOpenDialog()}>
                                  <AddCircleIcon />
                                </IconButton>
                                {t("GENERAL.add").toUpperCase()}
                              </span>
                            ) : (
                              <div style={{ marginRight: "2rem" }}></div>
                            )}
                          </div>
                          <React.Fragment>
                            {values.recessHistory && filteredRows.length > 0 ? (
                              <ScholarshipRecessesHistoryTable
                                rows={values.recessHistory}
                                headers={[
                                  "id",
                                  "contractId",
                                  "startDate",
                                  "endDate",
                                  "createdAt",
                                  "updatedAt",
                                  "deletedAt",
                                  "operator",
                                  "note",
                                ]}
                                visibleHeaders={[
                                  "Período de Recesso",
                                  "Data de Lançamento",
                                  "Operado por",
                                  "",
                                ]}
                                sortedFields={[
                                  "startDate",
                                  "endDate",
                                  "createdAt",
                                  "operator",
                                ]}
                                mainField="startDate"
                                context={context}
                                itemList={values}
                              />
                            ) : (
                              <div className={classes.noParticipantsMessage}>
                                <h3 style={{ paddingTop: 30 }}>
                                  {t("HR.recessesNotAvailable")}
                                </h3>
                              </div>
                            )}
                          </React.Fragment>
                        </Paper>
                      </Grid>
                      <Box style={{ marginBottom: "50px" }} />
                    </Grid>
                  </Grid>
                </React.Fragment>
              </Paper>
            </Transition>
          </Paper>
        </div>
      </div>
      <Footer style={{ display: "flex" }} />
      {open && (
        <DialogViewScholarshipRecess
          open={open}
          setOpen={setOpen}
          context={"new"}
          item={values}
        />
      )}
    </React.Fragment>
  );
};

export default ScholarshipsRecessesForm;
